export class Option {
    id  ;
    name  ;
}